import React, { useEffect, useCallback, useState} from 'react';
import {
    setPresetDragging,
    setLoadingText
} from 'actions/index.js';
import {connect} from 'react-redux';
import {INSTRUMENT_TYPE_TO_NAME} from 'constants/instrument-types.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const PresetOption = ({sequencerEngine, preset, setPresetDragging, setLoadingText}) => { 
    let dotStyle = {
        backgroundColor: colors.getColorForHash(INSTRUMENT_TYPE_TO_NAME[preset.instrumentType])
    };

    const onClick = () => {
        setLoadingText("Loading Preset (" + preset.title + ")");
        sequencerEngine.loadPreset(
            preset, true)
            .then(s => setLoadingText(undefined));
    };
    return (
        <div
          draggable={true}
          onDragOver={(e) => e.preventDefault()}
          onDragStart={() => setPresetDragging(preset)}
          className="sample-option">
          <div onClick={onClick} className="dot" style={dotStyle}/>
          <div
            className="wave-and-name">
            <div className="name-and-tags">
              <div className="sample-name">{preset.title}</div>
              <div style={dotStyle} className="instrument-type">
                {INSTRUMENT_TYPE_TO_NAME[preset.instrumentType]}
              </div>
              {preset.tags.map(tag => <div className="tag-option">{tag}</div>)}
            </div>
            <div className="waveform-and-rating">
            </div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPresetDragging: (x) => dispatch(setPresetDragging(x)),
      setLoadingText: (x) => dispatch(setLoadingText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetOption);
